import createImageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectors as CreditDemandeSelectors } from "redux/slices/v2/DemandeUnCredit";
import SanityHeadSeo from "../../sanity/Components/SanityHeadSeo/SanityHeadSeo";
import ConsultantComponent from "../../SanityComponents/CreditImmobilierComponents/DemandeUnCredit/consultantComponent/ConsultantComponent";
import FifthStep from "../../SanityComponents/CreditImmobilierComponents/DemandeUnCredit/FifthStep/FifthStep";
import FirstStep from "../../SanityComponents/CreditImmobilierComponents/DemandeUnCredit/FirstStep.tsx/FirstStep";
import FourthStep from "../../SanityComponents/CreditImmobilierComponents/DemandeUnCredit/FourthStep/FourthStep";
import SecondStep from "../../SanityComponents/CreditImmobilierComponents/DemandeUnCredit/SecondStep/SecondStep";
import ThirdStep from "../../SanityComponents/CreditImmobilierComponents/DemandeUnCredit/ThirdStep/ThirdStep";
import styles from "./styles.module.css";
import WhatssapComponent from "SanityComponents/WhatssapComponent";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});

function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

function DemandCredit({ data }) {
  const activeStep = useSelector(CreditDemandeSelectors.activeStepSelector);
  useEffect(() => {}, [activeStep]);
  const { t, lang } = useTranslation("connexionInscription");

  return (
    <div className={styles.main}>
      {data?.content.map((item, key) => {
        if (item.DemandeCreditSteps?.length > 0) {
          return (
            <>
              <div className={styles.leftSide}>
                <>
                  {item.DemandeCreditSteps.map((elem, index) => {
                    return (
                      <>
                        {elem.Name == "First step" && activeStep == 1 ? (
                          <FirstStep
                            t={t}
                            lang={lang}
                            titre={elem.titre ? elem.titre[lang] : null}
                            subTitle={
                              elem.subTitle ? elem.subTitle[lang] : null
                            }
                            choices={elem.choices ? elem.choices : null}
                            Title2={elem.Title2 ? elem.Title2[lang] : null}
                            choices2={elem.choices2 ? elem.choices2 : null}
                            title3={elem.title3 ? elem.title3[lang] : null}
                            villeChoices={
                              elem.villeChoices ? elem.villeChoices : null
                            }
                            Button_text={
                              elem.Button_text ? elem.Button_text[lang] : null
                            }
                            Button_link={
                              elem.Button_link ? elem.Button_link : null
                            }
                          />
                        ) : null}
                        {elem.Name == "second step" && activeStep == 2 ? (
                          <SecondStep
                            t={t}
                            lang={lang}
                            titre={elem.titre ? elem.titre[lang] : null}
                            subTitle={
                              elem.subTitle ? elem.subTitle[lang] : null
                            }
                            choices={elem.choices ? elem.choices : null}
                            Title2={elem.Title2 ? elem.Title2[lang] : null}
                            choices2={elem.choices2 ? elem.choices2 : null}
                            title3={elem.title3 ? elem.title3[lang] : null}
                            villeChoices={
                              elem.villeChoices ? elem.villeChoices : null
                            }
                            Button_text={
                              elem.Button_text ? elem.Button_text[lang] : null
                            }
                            Button_texte={
                              elem.Button_texte ? elem.Button_texte[lang] : null
                            }
                          />
                        ) : null}
                        {elem.Name == "third step" && activeStep == 3 ? (
                          <ThirdStep
                            t={t}
                            lang={lang}
                            titre={elem.titre ? elem.titre[lang] : null}
                            subTitle={
                              elem.subTitle ? elem.subTitle[lang] : null
                            }
                            choices={elem.choices ? elem.choices : null}
                            Title2={elem.Title2 ? elem.Title2[lang] : null}
                            choices2={elem.choices2 ? elem.choices2 : null}
                            Title3={elem.title3 ? elem.title3[lang] : null}
                            villeChoices={
                              elem.villeChoices ? elem.villeChoices : null
                            }
                            Button_text={
                              elem.Button_text ? elem.Button_text[lang] : null
                            }
                            Button_texte={
                              elem.Button_texte ? elem.Button_texte[lang] : null
                            }
                          />
                        ) : null}
                        {elem.Name == "fourth step" && activeStep == 4 ? (
                          <FourthStep
                            t={t}
                            lang={lang}
                            titre={elem.titre ? elem.titre[lang] : null}
                            subTitle={
                              elem.subTitle ? elem.subTitle[lang] : null
                            }
                            choices={elem.choices ? elem.choices : null}
                            Title2={elem.Title2 ? elem.Title2[lang] : null}
                            choices2={elem.choices2 ? elem.choices2 : null}
                            title3={elem.title3 ? elem.title3[lang] : null}
                            villeChoices={
                              elem.villeChoices ? elem.villeChoices : null
                            }
                            Button_text={
                              elem.Button_text ? elem.Button_text[lang] : null
                            }
                            Button_texte={
                              elem.Button_texte ? elem.Button_texte[lang] : null
                            }
                          />
                        ) : null}
                        {elem.Name == "fifth step" && activeStep == 5 ? (
                          <FifthStep
                            titre={elem.titre ? elem.titre[lang] : null}
                            subTitle={
                              elem.subTitle ? elem.subTitle[lang] : null
                            }
                            choices={elem.choices ? elem.choices : null}
                            Title2={elem.Title2 ? elem.Title2[lang] : null}
                            choices2={elem.choices2 ? elem.choices2 : null}
                            title3={elem.title3 ? elem.title3[lang] : null}
                            villeChoices={
                              elem.villeChoices ? elem.villeChoices : null
                            }
                            Button_text={
                              elem.Button_text ? elem.Button_text[lang] : null
                            }
                            Button_link={
                              elem.Button_link ? elem.Button_link : null
                            }
                            Button_text2={
                              elem.Button_texte ? elem.Button_texte[lang] : null
                            }
                            Button_link2={
                              elem.ButtonLink ? elem.ButtonLink : null
                            }
                          />
                        ) : null}
                      </>
                    );
                  })}
                </>
              </div>
            </>
          );
        } else if (item._type == "WhatssapComponent") {
          return (
            <WhatssapComponent
              number={item?.numberPhone ? item.numberPhone : null}
              message={item?.message ? item.message[lang] : null}
            />
          )
        } else if (item._type == "SanityHeadSeo") {
          return (
            <SanityHeadSeo
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              ogTitle={item.titre ? item.titre[lang] : ""}
              description={item.description ? item.description[lang] : ""}
              ogDescription={item.description ? item.description[lang] : ""}
              canonicalUrl={item.canonicalUrl}
              ogTwitterImage={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              ogType={item.ogType}
              ogImageUrl={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              structuredData={null}
            >
              <></>
            </SanityHeadSeo>
          );
        } else if (item._type == "consultant") {
          return (
            <div className={styles.rightSide}>
              <ConsultantComponent
                logo={urlFor(item?.logo)
                  .format("webp")
                  .auto("format")
                  .fit("clip")
                  .auto("format")
                  .toString()}
                titre={item.titre ? item.titre[lang] : ""}
                subTitle1={item.subTitle1[lang]}
                numberPhone={item.numberPhone}
                subTitle2={item.subTitle2[lang]}
              />
            </div>
          );
        }
      })}
    </div>
  );
}

export default DemandCredit;
